// extracted by mini-css-extract-plugin
export default {"pill":"kpiDeltaPill_pill__tW7ru","toneUp":"kpiDeltaPill_toneUp__q2o04","toneDown":"kpiDeltaPill_toneDown__K+jIR"};